<template>
  <!--
    **押した結果を、押したボタンのそばに出すための部品。**

    画面のいちばん上の帯にだけ結果を出していた画面では、押したボタンが
    下のほうにあると結果が見えず、「押しても何も起きない」と言われた
    （2026-09-26、権限管理の［追加］）。権限管理（TenantAccessManagement.vue の
    row-message）で入れた見た目を、ほかの画面でも同じに出せるよう部品にした。

    - 成功は role="status"、失敗は role="alert"（読み上げの強さを分ける）。
    - 文が変わって画面の外にあるときは、見える所まで画面を動かす（小窓の中や
      長いフォームの一番下で押したとき、結果を探させないため）。
  -->
  <p
    v-if="text"
    ref="message"
    :role="type === 'danger' ? 'alert' : 'status'"
    :class="['action-result-message', 'action-result-message--' + type]"
  >
    {{ text }}
  </p>
</template>

<script>
const TYPES = ['success', 'danger', 'info']

export default {
  name: 'ActionResultMessage',
  props: {
    text: { type: String, default: '' },
    type: {
      type: String,
      default: 'success',
      validator: value => TYPES.includes(value)
    },
    // 出たときに見える所まで画面を動かすか。行の中に並べて出す画面など、
    // 動くと邪魔になる所では false にする。
    reveal: { type: Boolean, default: true }
  },
  watch: {
    text (value) {
      if (!value || !this.reveal) return
      this.$nextTick(() => {
        const el = this.$refs.message
        if (el && typeof el.scrollIntoView === 'function') {
          el.scrollIntoView({ block: 'nearest' })
        }
      })
    }
  }
}
</script>

<style scoped>
.action-result-message {
  margin: 8px 0 0;
  padding: 6px 10px;
  border-radius: 6px;
  font-size: .875rem;
  line-height: 1.6;
  overflow-wrap: anywhere;
}
.action-result-message--success {
  color: #0f5132;
  background: #d1e7dd;
}
.action-result-message--danger {
  color: #842029;
  background: #f8d7da;
}
.action-result-message--info {
  color: #055160;
  background: #cff4fc;
}
</style>
